export default {
  targetsMetadata: {
    roleSelf: 'My',
    roleCurator: 'Curated by me',
    statuses: {
      awaitingReview: 'Awaiting review',
      approved: 'Approved',
      inProgress: 'In progress',
      inReview: 'In review by supervisor/curator',
      inReviewAssignee: 'In review by assignee',
      completed: 'Completed',
      cancelled: 'Cancelled',
    },
    scoreLabels: {
      low: 'Failed to reach<br/>major progress',
      middle: 'Reach progress,<br/>but no results',
      high: 'Result<br/>reached',
    },
    buttons: {
      approve: 'Approve',
      complete: 'Complete and start the assessment',
      change: 'Yes, change',
    },
    curator: 'Supervisor/Curator',
    noCurator: 'not assigned',
    tableHeaders: {
      name: 'Name',
      importance: 'Importance',
      employeeScore: 'Employee score',
      curatorScore: 'Supervisor/Curator score',
      curatorScoreMobile: 'Supervisor/Curator score',
      employeeAvg: 'Average self-esteem',
      curatorAvg: 'Average score </br> of the Supervisor/Curator',
      efficiency: 'Efficiency',
      status: 'Status',
      type: 'Type',
      progress: 'Progress',
      deadline: 'Deadline',
    },
    confirmMoveTargets: {
      title: 'Change the status of targets?',
      text: 'The status of the selected targets will be changed to: «{status}»',
    },
    tooltips: {
      efficiency: 'Percentage of completed targets out of agreed ones',
      scoreAvg:
        'The average score is calculated as the arithmetic weighted average of all target scores: the sum of targets multiplied by their weights divided by the sum of all weights. The weight of the target is determined automatically depending on the set importance.',
    },
    successMessages: {
      moveTarget: 'The status of the target «{targetName}» successfully changed',
    },
    errorMessages: {
      moveTarget: 'Failed to change the status of the target «{targetName}»',
    },
    noTargets:
      'You do not have any targets yet. To add a target, click on the «Add a target» button',
    noArchivalTargets: 'You do not have any archival targets yet.',
    disabledButton: 'To add a target, you must join a team that has a Team Leader',
  },
};
